import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./GlobalDownloadCTA.css";

function GlobalDownloadCTA() {
  const { t } = useTranslation();
  const location = useLocation();
  const isDownloadPage = location.pathname.toLowerCase() === "/download";

  const handleClick = () => {
    if (isDownloadPage) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <Link
      to="/download"
      className={`global-download-cta${isDownloadPage ? " is-current" : ""}`}
      onClick={handleClick}
      aria-label={`${t("nav.download")} IKI AI`}
      aria-current={isDownloadPage ? "page" : undefined}
    >
      <span className="global-download-cta__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" focusable="false">
          <path d="M12 3v11m0 0 4-4m-4 4-4-4M5 17v2h14v-2" />
        </svg>
      </span>
      <span className="global-download-cta__label">
        <span>{t("nav.download")}</span>
        <strong>IKI AI</strong>
      </span>
    </Link>
  );
}

export default GlobalDownloadCTA;
